
import { AbstractControl, ValidationErrors, ValidatorFn, Validator, NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';
import { Subscription } from 'rxjs';
export class IsEqualOrLessThanValidator {
    static EqualOrLessThan(equalOrLessThanControlName): ValidatorFn {

        return (control: AbstractControl): ValidationErrors | null => {

            if (!control.root) return null;

            const controlMatch = control.root.get(equalOrLessThanControlName);

            if (!controlMatch) return null;


            const subscription: Subscription = controlMatch.valueChanges.subscribe(() => {
                control.updateValueAndValidity();
                subscription.unsubscribe();
            });

            if (+control.value > +controlMatch.value) {
                controlMatch.setErrors({ 'isEqualOrGreaterThan': true });
                return { 'isEqualOrLessThan': true };
            }

            if (controlMatch.errors) {
                delete controlMatch.errors['isEqualOrGreaterThan'];
                controlMatch.updateValueAndValidity({ emitEvent: false });

            }

            return null;
        };
    }
}


@Directive({
    selector: '[appIsEqualOrLessThanValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: IsEqualOrLessThanValidatorDirective, multi: true }]
})
export class IsEqualOrLessThanValidatorDirective implements Validator {
    @Input('appIsEqualOrLessThanValidator') equalOrLessThanControlName: string;

    validate(control: AbstractControl): ValidationErrors {

        if (!control.root) return null;

        const controlMatch = control.root.get(this.equalOrLessThanControlName);

        if (!controlMatch) return null;


        const subscription: Subscription = controlMatch.valueChanges.subscribe(() => {
            control.updateValueAndValidity();
            subscription.unsubscribe();
        });

        if (+control.value > +controlMatch.value) {
            // controlMatch.setErrors({ 'isEqualOrGreaterThan': true });
            return { 'isEqualOrLessThan': true };
        }

        // if (controlMatch.errors) {
        //     delete controlMatch.errors['isEqualOrGreaterThan'];
        //     controlMatch.updateValueAndValidity({ emitEvent: false });
        // }

        return null;
    }
}
